import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const documentCategoryService = createApi({
    reducerPath: 'documentCategoryService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['DocumentCategory'],
    endpoints: (builder) => ({
        getAllDocumentCategory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentCategoryController.getAllDocumentCategory}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                    // body: body.payload,
                }
            }
        }),
        getDocumentCategoryById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentCategoryController.getDocumentCategoryById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                    // body: body.payload,
                }
            }
        }),
        saveDocumentCategory: builder.mutation({
            query(body){
                return {
                    url: `${userManagement.documentCategoryController.saveDocumentCategory}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateDocumentCategory: builder.mutation({
            query(body){
                return {
                    url: `${userManagement.documentCategoryController.updateDocumentCategory}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteDocumentCategory: builder.mutation({
            query(body){
                return {
                    url: `${userManagement.documentCategoryController.deleteDocumentCategory}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }   
            }
        }),
        getAllDocumentCategoryWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentCategoryController.getAllDocumentCategoryWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllDocumentCategory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.documentCategoryController.findAllDocumentCategory}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllDocumentCategoryMutation,
    useSaveDocumentCategoryMutation,
    useUpdateDocumentCategoryMutation,
    useDeleteDocumentCategoryMutation,
    useGetDocumentCategoryByIdMutation,
    useGetAllDocumentCategoryWithSearchMutation,
    useFindAllDocumentCategoryMutation,
  } = documentCategoryService;